import {IS_LOGIN, IS_LOGIN_ERROR} from '../types'
import axios from 'axios'
import { ROUTE, PATH } from "../constants";

export const is_login = () => {
    return !(localStorage.getItem('token') == null || localStorage.getItem('token') == "")
};
